/**
 * @generated SignedSource<<c504d631e8453c3449ea5eb0cc07a60f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type initSupportChat_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"initSierraChat_user">;
  readonly " $fragmentType": "initSupportChat_user";
};
export type initSupportChat_user$key = {
  readonly " $data"?: initSupportChat_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"initSupportChat_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "initSupportChat_user"
};

(node as any).hash = "3ea8837f80d6181a312f8a4feb8a4ecc";

export default node;
